import { carrierSubmissionFieldsConfig } from '../config';
import { TriageOutput } from '../enums';

export function isValueFilled(value: unknown): boolean {
    if (value == null) {
        return false;
    }
    if (typeof value === 'string') {
        return value.trim().length > 0;
    }
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return true;
}

export function areRequiredFieldsFilled(values: Record<string, unknown>): boolean {
    return Object.entries(carrierSubmissionFieldsConfig).every(([key, config]) => {
        if (!config.isRequired) {
            return true;
        }

        const value = values[key];

        if (config.nestedRequiredFields) {
            if (value == null || typeof value !== 'object') {
                return false;
            }
            const nested = value as Record<string, unknown>;
            return config.nestedRequiredFields.every((nestedKey) => isValueFilled(nested[nestedKey]));
        }

        return isValueFilled(value);
    });
}

export function calculateTriageOutput(values: Record<string, unknown>): TriageOutput {
    return areRequiredFieldsFilled(values) ? TriageOutput.InGoodOrder : TriageOutput.NotInGoodOrder;
}
